"use client";

import React from "react";
import { Button } from "@/components/ui/button";
import { AlertTriangle, RefreshCw, Home } from "lucide-react";
import Link from "next/link";

export default function AppErrorBoundary({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <main className="flex min-h-screen items-center justify-center p-8">
      <div className="text-center max-w-sm animate-fade-in">
        <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-2xl bg-surface-tertiary">
          <AlertTriangle className="h-6 w-6 text-fg-tertiary" />
        </div>
        <h1 className="mt-6 font-heading text-9 font-semibold tracking-tight text-fg">Something went wrong</h1>
        <p className="mt-2 text-3 text-fg-secondary leading-relaxed">
          An unexpected error occurred. Please try refreshing the page.
        </p>
        <div className="mt-8 flex items-center justify-center gap-3">
          <Button onClick={reset} size="sm">
            <RefreshCw className="mr-1.5 h-3.5 w-3.5" /> Try Again
          </Button>
          <Button variant="outline" size="sm" asChild>
            <Link href="/">
              <Home className="mr-1.5 h-3.5 w-3.5" /> Home
            </Link>
          </Button>
        </div>
      </div>
    </main>
  );
}
